import api from "utils/api";

export const startDbOperations = async () => {
  const res = await api.post("/inventory/run-db-ops/");
  return res.data;
};

export const getDbOpsStatus = async (jobId) => {
  const res = await api.get(`/inventory/run-db-ops/${jobId}/status/`);
  return res.data;
};
